<template>
  <div>
    <DialogBase
      v-model="inputValue"
      :title="
        $t('common.common_sale-channel') +
        (editMode ? $t('common.common_edit') : $t('common.common_register'))
      "
      :width="width"
    >
      <div class="px-5 pb-5">
        <InputFormNew
          v-model="inputData"
          :detail="items"
          :titleCols="inputFormStyle.titleCols"
          :contentsCols="inputFormStyle.contentsCols"
          :master-data="customerCutegories"
        />
        <NormalButton
          :text="buttonName"
          textSize="16px"
          height="50px"
          width="100%"
          class="pt-5"
          @click.native="complete()"
        />
      </div>
    </DialogBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import { InputFormNew, NormalButton } from '@/components/items'
import { i18n } from '@/main'

export default {
  components: {
    DialogBase,
    InputFormNew,
    NormalButton
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    customerCategoryData: { type: Object, require: false, default: () => ({}) },
    editMode: { type: Boolean, require: false, default: false }
  },
  data: () => ({
    inputFormStyle: {
      titleCols: 5,
      contentsCols: 7
    },
    inputData: {},
    buttonName: i18n.tc('common.input_save'),
    customerCutegories: [],
    items: [
      {
        name: 'name',
        // 顧客分類名,
        text: i18n.tc('customer.customer_sale-channel-name'),
        required: true
      },
      {
        name: 'sortNumber',
        // ソート順
        text: i18n.tc('common.input_sort-number'),
        required: true,
        placeholder: '',
        cols: Math.ceil(5),
        component: 'SelectSortNumber'
      },
      {
        name: 'isEnabled',
        text: 'product.product_display-setting',
        component: 'CheckEnabled'
      }
    ]
  }),

  created() {
    this.init()
  },

  methods: {
    ...mapActions('Common', [
      'registerCustomerCategory',
      'editCustomerCategory'
    ]),
    ...mapGetters('Common', [
      'getCustomerCategoryMaxSortNumber',
      'getCustomerCategoryFromState'
    ]),

    init() {
      const formatData = { ...this.customerCategoryData }
      // 新規登録の際に「表示する」項目のダイアログ初期値をtrueで設定
      if (!Object.keys(formatData).length) {
        formatData.isEnabled = true
      }
      formatData.sortNumber = this.editMode
        ? this.customerCategoryData.sortNumber
        : this.getCustomerCategoryMaxSortNumber() + 1

      this.inputData = formatData
      this.customerCutegories = this.getCustomerCategoryFromState()
    },
    async complete() {
      if (this.editMode) {
        this.inputData.id = this.inputData.customerCategoryId
      }
      const success = this.editMode
        ? await this.editCustomerCategory(this.inputData)
        : await this.registerCustomerCategory(this.inputData)

      if (success) {
        this.$emit('success')
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    inputValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}
</style>
